import * as tslib_1 from "tslib";
import React, { useMemo } from 'react';
import _ from 'lodash';
import { useLocalize } from '../../../hooks';
import { Text } from '../Text';
import { CheckboxInput } from '../../fields';
export const CheckboxField = (_a) => {
    var { id, type, value, label, defaultLabelId, onChanged, onSetValue } = _a, rest = tslib_1.__rest(_a, ["id", "type", "value", "label", "defaultLabelId", "onChanged", "onSetValue"]);
    const { form, field, errorAfterSubmit } = rest;
    const { values, setFieldValue, submitCount, errors, touched } = form;
    const error = _.get(touched, id) ? _.get(errors, id) : undefined;
    const inputType = type || 'checkbox';
    const fieldId = `${id}.${value}`;
    // showError will only show errors when field is touched or after submit if errorAfterSubmit is true
    const showError = errorAfterSubmit ? !!submitCount : !!_.get(touched, id);
    const { getFieldTranslationId } = useLocalize();
    const checked = useMemo(() => {
        const currentValue = _.get(values, id);
        return _.isArray(currentValue) ? _.includes(currentValue, value) : value ? currentValue === value : !!currentValue;
    }, [id, values, value]);
    const handleOnChange = (_e, newValue) => {
        if (onSetValue) {
            onSetValue(newValue);
        }
        else {
            setFieldValue(id, newValue);
        }
        if (onChanged) {
            onChanged(newValue);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckboxInput, Object.assign({ name: id, id: fieldId, type: inputType, label: label || React.createElement(Text, { id: getFieldTranslationId({ id, defaultLabelId }), type: "field" }), checked: checked, onchange: handleOnChange, onblur: field.onBlur, error: error }, rest)),
        id !== 'tradeGoalType' && id !== 'investmentObjectiveType' && error && showError && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement("span", { className: "error" },
                React.createElement(Text, { id: id, textKey: `${error}`, type: 'error' }))))));
};
//# sourceMappingURL=Checkbox.js.map